module.exports = __webpack_public_path__ + "img/three1Blue.afe621fe.jpg";